import { Sprite } from 'pixi.js';

export class RewardSparkle extends Sprite {
    private animated: PIXI.extras.AnimatedSprite;

    constructor(scale: number) {
        super();

        const assets = PIXI.utils.TextureCache;
        const frames = [
            assets['fx/reward_boxVFX0001'],
            assets['fx/reward_boxVFX0002'],
            assets['fx/reward_boxVFX0003'],
            assets['fx/reward_boxVFX0004'],
            assets['fx/reward_boxVFX0005'],
            assets['fx/reward_boxVFX0006'],
            assets['fx/reward_boxVFX0007'],
            assets['fx/reward_boxVFX0008'],
            assets['fx/reward_boxVFX0009'],
            assets['fx/reward_boxVFX0010'],
            assets['fx/reward_boxVFX0011'],
            assets['fx/reward_boxVFX0012'],
            assets['fx/reward_boxVFX0013'],
        ];

        const anim = new PIXI.extras.AnimatedSprite(frames);
        anim.scale.set(scale);
        anim.anchor.set(0.5);
        this.addChild(anim);

        this.animated = anim;
        this.animated.animationSpeed = 0.25;
        this.animated.loop = false;
    }

    public play(cb?: () => void) {
        this.animated.play();
        this.animated.onComplete = () => {
            if (cb) {
                cb();
            }
            this.destroy();
        };
    }
}
